
<div class="d-inline-block" ngbDropdown #myDrop="ngbDropdown" [autoClose]="false">
  <button class="ps-1 btn iconWithBadge basketPreviewContainer pe-0 pe-lg-0"
    #basketButton
    id="dropdownManual"
    [attr.data-count]="numArticles > 0 ? numArticles : ''"
    [ngClass]="[adding ? 'adding' : '', isDealer ? 'iconOnly' : '']"
    style="background: none; color: #FFF"
    ngbDropdownAnchor
    (click)="gotoBasket(myDrop)"
    (mouseleave)="stopTimer(myDrop)"
    (mouseenter)="showDropdown(myDrop)"
    [ngClass]="changing ? 'changing' : ''"
    [ngbPopover]="freeShippingPopoverContent"
    [popoverTitle]="''"
    [autoClose]="false"
    triggers="manual"
    #popover="ngbPopover"
    placement="left"
    container="body">
    @for (article of addedArticles; track article; let i = $index) {
      @if (article.thumbs && article.thumbs.length) {
        <i class="part-icon" [ngStyle]="{'animation-delay': (i *250) + 'ms'}">
          <img [src]="article.thumbs[0]" style="width: 32px; height: auto">
        </i>
      }
    }
    <i class="material-icons basket-icon light">
      shopping_basket
    </i>
    @if (!isDealer) {
      <small class="d-block text-end pe-2">{{"BASKET" | translate}}</small>
    }
    @if (loading) {
      <div class="spinner spinner-border text-light spinner-border-sm position-absolute" style="pointer-events: none;" role="status">
        <span class="visually-hidden">{{'LOADING'|translate}}</span>
      </div>
    }
  </button>

  <!-- Free Shipping Popover Content -->
  <ng-template #freeShippingPopoverContent>
    <div class="free-shipping-popover-content hideForShowroomMode" style="width: 220px; font-size: 0.8rem;">
      <button type="button" class="btn-close float-end" aria-label="Close" (click)="closeFreeShippingPopover()"></button>
      <div class="clearfix my-4"></div>
      @if (basket && basket.id && !showroomMode) {
        <app-free-shipping-progress
          [basketId]="basket.id"
          [showDetails]="false"
          [total]="basketSum['parts']"
          [type]="'Parts'"
          [threshold]="getShippingThreshold('Parts')"
          [shippingCostValue]="getShippingCostValue('Parts')"
          [currencyCode]="getShippingCurrency('Parts')">
        </app-free-shipping-progress>
      }
    </div>
  </ng-template>

  <div ngbDropdownMenu aria-labelledby="dropdownManual" class="py-0" (clickOutside)="closeDropdown(myDrop, true)" (mouseenter)="cursorOutModal = false"
    (mouseleave)="closeDropdown(myDrop)">
    @if (loading && !basket?.items?.length) {
      <div class="p-3 col-12 bg-white"><div class="spinner spinner-border spinner-border-sm"> <span class="visually-hidden">{{'LOADING'|translate}}</span>
    </div></div>
  }
  @if (!basket && !loading) {
    <div class="p-2 col-12 bg-white">
      <p class="p-3 mb-0">{{'YOU_HAVE_NO_ARTICLES'|translate}}</p>
      @if (!basket) {
        <span class="mt-2 me-2 btn btn-dark btn-lg mb-1"
          (click)="myDrop.close()">{{
          'CLOSE' |
        translate}}</span>
      }
    </div>
  }
  @if (basket) {
    <div class="ps-1 ps-sm-3 p-sm-3 pb-5 dropDownContainer">
      <span class="position-absolute end-0 me-3 close clickable withOpacity" style="z-index: 99;" (click)="myDrop.close()">
        <i class="material-icons">close</i>
      </span>
      <div class="groupedArticles customScrollbar">
        <div class="position-relative">
          <!-- Locked basket overlay -->
          @if (basket.locked) {
            <div class="top-0 basket-locked position-absolute w-100 h-100 d-flex justify-content-center align-items-top">
              <div class="flex mt-5 justify-content-center align-items-center">
                <span class="me-2 material-icons text-danger">
                  lock
                </span>
                <span class="me-3">{{ 'BASKET_LOCKED' | translate }}</span><button class="btn btn-sm btn-outline-primary" (click)="unlockBasket()">{{ 'UNLOCK_BASKET' | translate }}</button>
              </div>
            </div>
          }
          <!-- Parts -->
          @if (groupedArticles && groupedArticles['parts'] && groupedArticles['parts'].items.length) {
            <app-grouped-articles
              [groupedArticles]="groupedArticles['parts']" (contentChanged)="calcTotal(articles)"
              [currency]="basket.total_price?.currency" [header]="'PARTS'" [sum]="basketSum['parts']" [compact]="true"
            [basketId]="basket.id"></app-grouped-articles>
          }
          <!-- Free Shipping Progress -->
          @if (basket && basket.id && articles && articles.length && !showroomMode) {
            <div class="px-3 my-2">
              <app-free-shipping-progress
                [basketId]="basket.id"
                [total]="basketSum['parts']"
                [type]="'Parts'"
                [threshold]="getShippingThreshold('Parts')"
                [shippingCostValue]="getShippingCostValue('Parts')"
                [currencyCode]="getShippingCurrency('Parts')">
              </app-free-shipping-progress>
            </div>
          }
          <!-- Bicycles -->
          @if (groupedArticles && groupedArticles['bicycles'] && groupedArticles['bicycles'].items.length) {
            <app-grouped-articles
              [groupedArticles]="groupedArticles['bicycles']" (contentChanged)="calcTotal(articles)"
              [currency]="basket.total_price?.currency" [header]="'BICYCLES'" [sum]="basketSum['bicycles']" [compact]="true"
            [basketId]="basket.id"></app-grouped-articles>
          }
          @if ((articles && !articles.length) || !articles) {
            <p class="px-3">{{'YOU_HAVE_NO_ARTICLES'|translate}}</p>
          }
        </div>
      </div>
      <div class="px-2 mt-3 col-md-12 d-flex">
        <ul class="w-100 px-0 pb-0 mb-0 list-group list-group-flush col-md-12 pt-1">
          <li class="px-0 list-group-item">
            <div class="w-100 d-flex">
              <div class="ps-0 col-md-9 buttons">
                @if (articles && articles.length) {
                  <a class="float-left me-2 btn btn-dark btn-lg mb-1"
                    (click)="myDrop.close()" [routerLink]="[selectedCompanyGroup + '/basket/' + basket.id]" [queryParams]="{checkout: true}">{{
                    'CHECKOUT' |
                  translate}}</a>
                }
                @if (articles && articles.length) {
                  <a class="float-left me-2 btn btn-success btn-lg mb-1"
                    (click)="myDrop.close()" [routerLink]="[selectedCompanyGroup + '/basket/' + basket.id]">{{
                    'VIEW'
                    |
                  translate}}</a>
                }
                <button class="btn btn-light btn-lg mb-1" (click)="myDrop.close()">
                  <a [routerLink]="'/' + selectedCompanyGroup + '/baskets/'">{{'ALL_BASKETS' | translate }}</a>
                </button>
              </div>
              @if (articles && articles.length && basket.shipping_cost) {
                <div class="ms-auto col-6 col-md-3 hideForShowroomMode sum totalSum"
                  >
                  @if (basket.shipping_cost && selectedCompanyGroup !== 'WG') {
                    <small class="d-block" style="font-size: 12px; text-wrap: balance">{{'SHIPPINGCOST' | translate }} <span
                    [innerHTML]="basket.shipping_cost.value | currencyConvert: basket.shipping_cost?.currency"></span></small>
                  }
                  {{'TOTAL' | translate }} <span class="d-block d-sm-inline-block"
                [innerHTML]="basketSum.totalWithShipping | currencyConvert: basket.shipping_cost?.currency"></span>
              </div>
            }
          </div>
        </li>
      </ul>
    </div>
  </div>
}
</div>
</div>
